<template>
    <div class="penalty">
      <div class="penalty-box" v-if="list.length > 0">
        <div class="title">点球大战</div>
        <div class="list">
          <div class="item flex-center" v-for="item in list" :key="item.round">
            <div class="player" v-if="item.homePlayerId">
               <div class="name flex-center">
                  <div>{{ item.homePlayerName }}</div>
                  <van-icon name="checked" color="#3FD57B" size="16px" v-if="item.homeGoalCount === 1"  />
                  <van-icon name="clear" color="#D54F3F" v-else />
               </div>
               <div class="text">
                <span v-if="item.homePlayerNumber">{{ item.homePlayerNumber }}号</span>
               </div>
            </div>
            <div class="player away" v-if="item.awayPlayerId">
               <div class="name flex-center">
                  <div>{{ item.awayPlayerName }}</div>
                  <van-icon name="checked" color="#3FD57B" v-if="item.awayGoalCount === 1"  />
                  <van-icon name="clear" color="#D54F3F"  v-else />
               </div>
               <div class="text">
                <span v-if="item.awayPlayerNumber">{{ item.awayPlayerNumber }}号</span>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getPenaltyShootoutData } from '@/api/match'
export default {
    data() {
        return {
          id: '',
          list: []
        };
    },
    mounted() {
      this.id = this.$route.query.gameId
      this.getPenaltyShootoutData()
    },
    methods: {
      getPenaltyShootoutData() {
        getPenaltyShootoutData({gameId: this.id}).then(res => {
          const { data } = res
          this.list = data
        })
      }
    },
};
</script>

<style scoped lang="scss">
.penalty-box{
  padding: 0px 11px;
  padding-bottom: 6px;
  background-color: #FFF;
  margin: 12px 0;
  .title{
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    padding: 12px 0;
    padding-left: 4px;
  }
  .list{
    .item{
      margin-bottom: 6px;
      .player{
        padding: 8px 12px;
        width: 171px;
        height: 50px;
        border-radius: 5px;
        background: linear-gradient(270deg, #E9F6FF 0%, rgba(233, 246, 255, 0) 100%);
        box-sizing: border-box;
        font-size: 14px;
        .name{
          color: #303133;
          line-height: 15px;
        }
        .text{
          color: #73767A;
          line-height: 17px;
          margin-top: 3px;
        }
      }
      .away{
        background: linear-gradient(90deg, #FEF0EA 0%, rgba(254, 245, 245, 0) 100%);
      }
    }
  }
}
</style>
